/// All  the view related constants can come here.

//
export const DEFAULT_WIDTH_ARROWED_CIRCLE_LOADER = 12;
export const DEFAULT_BIG_ARROWED_CIRCLE_LOADER = 'big';
export const SMALL_ARROWED_CIRCLE_LOADER = 'small';
export const SCREEN_WIDTH_VGA_1440 = 1440;
export const SCREEN_WIDTH_TABLET = 1280;
export const SCREEN_WIDTH_DESKTOP = 992;
export const SCREEN_WIDTH_MOBILE = 768;
export const REPORT_SCREEN_WHITESPACE_WIDTH = 140;
export const SCREEN_WIDTH_EXTRA_LARGE = 1590;
export const ANSWER_TRANSITION_TIMEOUT_BETWEEN_EDITED_AND_NORMAL_QUESTION = 2100;
export const TRANSITION_TIME_AFTER_EDIT_QUESTION = 200;
export const STATUS_SUSPEND = 'Suspend';
export const STATUS_RESTORE = 'Restore';
export const STATUS_INACTIVE = 'Inactive';
export const STATUS_RESET_PASSWORD = 'Reset Password';
export const STATUS_EDIT = 'Edit';


export const ACTION_EDIT = 'Edit';
export const ACTION_DELETE = 'Delete';
export const ACTION_ADD = 'Add';
export const ASSOCIATE_OWNER = 'Allocate Owner';
export const ACTION_CLONE = 'Clone';
export const ACTION_PERMISSION = 'Permission';
export const ACTION_DOCUMENT_ACCESS = 'Document Access';
export const ACTION_LENDING_LIMIT = 'Lending Limit';


export const BROKER_BASED_ALLOCATION = 'brocker_based_allocation';
export const ROUND_ROBIN_ALLOCATION = 'round_robin_allocation';
export const DIRECT_DEAL_ALLOCATION = 'direct_app_allocation';